export const days=[
    "Monday_Friday",
    "Tuesday_Thursday",
    "Wednesday_Saturday",
    "Sunday"
];

export const mealTime=[
    "Early_morning",
    "Pre_breakfast",
    "Breakfast",
    "Brunch",
    "Lunch",
    "Tea_Time",
    "Fruit_Time",
    "Evening_Snack",
    "Dinner",
    "Post_Dinner"
]

